import { css, mq, styled } from 'mymoria-ui';
import { Icon } from 'mymoria-ui/components';
import { useScrollDirection } from 'mymoria-ui/hooks';
import React from 'react';

const StyledMobileHeader = styled.div(
  ({ theme: { colors } }) => css`
    position: fixed;
    top: 0.2rem;
    left: 0;
    right: 0;
    height: 3.75rem;
    align-items: center;
    justify-content: center;
    background: ${colors.white};
    box-shadow: ${`0 5px 5px -5px  ${colors.gray}`};
    z-index: 1000;

    ${mq({
      display: ['flex', 'flex', 'none'],
    })};
  `,
);

const MobileLogo = styled(Icon.MymoriaLogo)`
  transform: scale(0.6);
`;

const HeaderMobile = () => {
  const { isTop } = useScrollDirection({ thresholdPixels: 80 });

  return (
    <StyledMobileHeader className={isTop ? 'visible' : 'hidden'}>
      <MobileLogo />
    </StyledMobileHeader>
  );
};

export default HeaderMobile;
